import { render } from "./NotificationDashboard.vue?vue&type=template&id=07c4c14b"
import script from "./NotificationDashboard.vue?vue&type=script&lang=js"
export * from "./NotificationDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__